/** Default learner fit reserves only room for the largest hotspot radius. */
export const HOTSPOT_INSETS = { horizontal: 48, top: 48, bottom: 48 };
// The editor toolbar ends at 68px; reserve only that plus control clearance.
export const EDITOR_HOTSPOT_INSETS = { horizontal: 48, top: 116, bottom: 48 };
// Extra scroll space lets learners move edge points clear of fixed page controls.
export const HOTSPOT_SCROLL_INSETS = { horizontal: 96, top: 160, bottom: 160 };
// Short editor frames scroll through a usable canvas.
export const EDITOR_HOTSPOT_MIN_HEIGHT = 376;
export const HOTSPOT_GAP = 8;
export interface HotspotPosition {
  left: number;
  top: number;
  size: number;
}
export function fitHotspotImage(
  w: number,
  h: number,
  imageW: number,
  imageH: number,
  insets = HOTSPOT_INSETS
) {
  const scale = Math.min(
    Math.max(1, w - insets.horizontal * 2) / imageW,
    Math.max(1, h - insets.top - insets.bottom) / imageH
  );
  return { width: imageW * scale, height: imageH * scale };
}
export function hotspotsOverlap(
  a: HotspotPosition,
  b: HotspotPosition,
  w: number,
  h: number
) {
  return (
    Math.hypot(((a.left - b.left) * w) / 100, ((a.top - b.top) * h) / 100) <
    (a.size + b.size) / 2 + HOTSPOT_GAP
  );
}
/** Authoring checks the canvas being edited; smaller screens can use zoom. */
export function overlapsHotspot(
  candidate: HotspotPosition,
  others: HotspotPosition[],
  rendered: { width: number; height: number }
) {
  return others.some(other =>
    hotspotsOverlap(candidate, other, rendered.width, rendered.height)
  );
}
